import { IUtilFunctions } from "./iutil-functions";
import { CrComLibAdaptor } from "./crcomlib-adaptor";

declare const CrComLib: any;

abstract class Creator {
  public abstract getCrComLib(): IUtilFunctions;
}

class testLib implements IUtilFunctions {
  subscribeState(
    signalType: string,
    signalName: string,
    callback: Function
  ): string {
    throw new Error("Method not implemented.");
  }
  publishEvent(
    signalType: string,
    signalName: string,
    value: string | number | boolean | object
  ): void {
    throw new Error("Method not implemented.");
  }
}
export class ComLibCreators extends Creator {
  public getCrComLib(): IUtilFunctions {
    return new CrComLibAdaptor(CrComLib);
    //return new testLib();
  }
}
